import React, { Component } from 'react';
import QRCode from 'qrcode';
import { Container, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Card from '../../components/Card/Card';
import PropTypes from 'prop-types';
import { getCurrentProfile } from '../../actions/profileAction';
//import Card from '../../components/Card/Card';
import Spinner from '../common/Spinner';
import { getStudentStats, getAllConferences, getConferenceStatus } from '../../actions/clientActions';
import { Accordion } from 'react-bootstrap';
import UserCard from '../UserCard/UserCard';
import dateFormat from "dateformat";
import { Slide } from 'react-awesome-reveal';

class StudentHomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: '',
      src: '',
    };
  }
  componentDidMount() {
    this.props.getConferenceStatus();
    this.props.getCurrentProfile();
    const email = this.props.auth.user.email;
    this.props.getStudentStats(email);
    //console.log(email + "Bi trebalo da je mail");
    QRCode.toDataURL(email).then(res => { this.setState({ src: res }) });
  }

  render() {
    const qrImage = (<img src={this.state.src} />)
    const { loading } = this.props.student;
    const students = this.props.participant.participantOwnStats;
    const conferences = this.props.participant.conferenceStatus;
    let confItems;
    if (conferences === null || loading) {
      confItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    } else {
      if (conferences.length > 0) {
        confItems = conferences.map(conference => (
          //<tr key={conference._id}>
          <Col md={4}>
            <UserCard key={conference._id}
              name={conference.conferenceFullName}
              userName={dateFormat(conference.conferenceDate, "dd.mm.yyyy.")}
              timeFrom={conference.conferenceTimeFrom}
              timeTo={conference.conferenceTimeTo}
              description={conference.conferenceDesc}
              socials={conference.speakerFullName}
            />
          </Col>
          /*<Accordion defaultActiveKey="0">
            <Accordion.Item>
              <Accordion.Header>
                <table style={{ width: '100%' }}>
                  <tr>
                    <td style={{ width: '60%' }}>{conference.conferenceFullName}</td>
                    <td style={{ width: '16%' }} />
                    <td style={{ width: '24%' }}>{conference.speakerFullName}</td>
                  </tr>
                </table>
              </Accordion.Header>
              <Accordion.Body>
                <table style={{ width: '100%' }}>
                  <tr>
                    <td style={{ width: '70%' }}>Opis predavanja:</td>
                    <td style={{ width: '5%' }} />
                    <td style={{ width: '12%' }}>Datum konferencije:</td>
                    <td style={{ width: '13%' }}>Vreme konferencije:</td>
                  </tr>
                  <tr>
                    <td style={{ width: '70%' }}>{conference.conferenceDesc}</td>
                    <td style={{ width: '5%' }} />
                    <td style={{ width: '12%' }}>{conference.conferenceDate}</td>
                    <td style={{ width: '13%' }}>{conference.conferenceTimeFrom} - {conference.conferenceTimeTo} </td>
                  </tr>
                </table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </tr>*/
        ));
      } else {
        confItems = (
          <tr>
            <td>Trenutno nema podataka za prikaz</td>
          </tr>
        );
      }
    }
    return (
      <div className="justify-content">
        <Container fluid>
          <Row className="justify-content-center">
            <div style={{ maxHeight: '300px', maxWidth: '300px', marginBottom: '25px' }}> {qrImage} </div>
          </Row>
          <Card
            title="Informacije o predavanjima"
            ctTableFullWidth
            ctTableResponsive
            content={
              <Slide triggerOnce>
                <Row>
                  {confItems}
                </Row>
              </Slide>

            }
          />
        </Container>
      </div>
    );
  }
}

StudentHomePage.propTypes = {
  student: PropTypes.object.isRequired,
  participant: PropTypes.object.isRequired,
  getStudentStats: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  getAllConferences: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  conference: PropTypes.object.isRequired,
  getConferenceStatus: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  student: state.student,
  conference: state.conference,
  participant: state.participant,
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  { getCurrentProfile, getStudentStats, getAllConferences, getConferenceStatus }
)(StudentHomePage);

/*             
<td style={{ border: '0px' }}>{conference.conferenceFullName}</td>  
<td style={{ border: '0px' }}>{conference.speakerFullName}</td>
<td style={{ border: '0px', wordBreak: 'break-word'}}>{conference.conferenceDesc}</td>
<td style={{ border: '0px' }}>{conference.conferenceDate}</td>
<td style={{ border: '0px' }}>{conference.conferenceTime}</td>
*/

/*
            <Accordion defaultActiveKey="0">
              <Accordion.Item>
                <Accordion.Header>
                  <table style={{ width: '100%' }}>
                    <tr>
                      <td>{conference.conferenceFullName}</td>
                      <td /> 
                      <td>{conference.SpeakerFullName}</td>
                    </tr>
                  </table>
                </Accordion.Header>
                <Accordion.Body>
                  <table style={{ width: '100%' }}>
                    <tr>
                      <td>{conference.conferenceDesc}</td>
                      <td>{conference.conferenceDate}</td>
                      <td>{conference.conferenceTime}</td>
                    </tr>
                  </table>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
*/